import type { CityConfig } from "../city-template/types";

export const redmondWAConfig: CityConfig = {
  city: "Redmond",
  state: "Washington",
  stateAbbr: "WA",
  slug: "redmond-wa",
  route: "/cities/redmond-wa",
  title: "Emergency Passport Redmond WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Redmond, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Redmond, Microsoft campus, Sammamish, and all Eastside residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Redmond, WA",
  heroSubtitle: "Redmond travelers — from Microsoft employees to Eastside tech families to Sammamish Plateau residents — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving the Eastside tech corridor and all of northeastern King County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Redmond%20Washington%20Microsoft%20campus%20headquarters%20with%20modern%20glass%20office%20buildings%20surrounded%20by%20lush%20Pacific%20Northwest%20greenery%2C%20Marymoor%20Park%20and%20Lake%20Sammamish%20in%20the%20distance%2C%20the%20Bear%20Creek%20and%20Sammamish%20River%20valleys%2C%20Eastside%20tech%20corridor%20atmosphere%2C%20modern%20suburban%20landscape%20with%20evergreen%20forests%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=redmond-wa-hero-001&orientation=landscape",
  heroImageAlt: "Redmond Washington Microsoft campus with Lake Sammamish and Eastside greenery",
  geoPosition: "47.6740;-122.1215",
  geoPlacename: "Redmond, Washington",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "Approximately 16 miles west of Redmond via SR-520",
  },
  nearbyCitiesZips: [
    { name: "Redmond", zips: "98052, 98053, 98073" },
    { name: "Bellevue", zips: "98004, 98005, 98006, 98007, 98008" },
    { name: "Kirkland", zips: "98033, 98034, 98083" },
    { name: "Sammamish", zips: "98074, 98075" },
    { name: "Issaquah", zips: "98027, 98029, 98075" },
    { name: "Woodinville", zips: "98072, 98077" },
    { name: "Duvall", zips: "98019" },
    { name: "Carnation", zips: "98014" },
    { name: "Fall City", zips: "98024" },
    { name: "Union Hill", zips: "98053" },
    { name: "Novelty Hill", zips: "98053" },
    { name: "Bothell", zips: "98011, 98012, 98021, 98041" },
    { name: "Kenmore", zips: "98028" },
    { name: "Mercer Island", zips: "98040" },
    { name: "Clyde Hill", zips: "98004" },
    { name: "Medina", zips: "98039" },
    { name: "Yarrow Point", zips: "98004" },
    { name: "Hunts Point", zips: "98004" },
    { name: "Kirkland", zips: "98033, 98034" },
    { name: "North Bend", zips: "98045" },
    { name: "Snoqualmie", zips: "98065" },
    { name: "Preston", zips: "98050" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 20 minutes across SR-520" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Microsoft & Tech Corridor Hub", desc: "Serving Microsoft HQ, Nintendo, and Eastside tech professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Redmond or Eastside location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Emergency passport help in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Urgent passport services in Kirkland, WA", route: "/cities/kirkland" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Redmond, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — just 20 minutes west via SR-520. Redmond residents can ship from any UPS or FedEx on the Eastside.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Redmond, Sammamish, Issaquah, Duvall, Carnation, Fall City, Woodinville, and all of northeastern King County and the Sammamish Plateau",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Redmond and the Eastside tech corridor. From the Microsoft Redmond campus spanning over 80 buildings across the city to the Sammamish Plateau communities, from Marymoor Park and the Sammamish River Trail to the Snoqualmie Valley — we serve all of Redmond and northeastern King County.",
  nearbyCitiesIntro: "We serve Redmond and all nearby communities including Bellevue, Kirkland, Sammamish, Issaquah, Woodinville, Duvall, Carnation, Fall City, Union Hill, Novelty Hill, Bothell, and Kenmore. We also serve the Sammamish Plateau and the Snoqualmie Valley communities.",
  howItWorksIntro: "Most Redmond travelers complete everything online and ship documents overnight. No need to drive across SR-520 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Redmond is the global headquarters of Microsoft and a major Eastside tech hub with significant international travel demand. Here are the most common passport mistakes we see from Redmond-area travelers.",
  testimonialsIntro: "Redmond travelers — from Microsoft engineers to tech families to Sammamish Plateau residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Redmond, WA? Here are the most common ones we hear from Eastside tech corridor travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive across Lake Washington to Seattle", "SR-520 bridge toll and downtown parking"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "No SR-520 bridge toll or downtown parking hassle", "Perfect for Microsoft and tech travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Redmond travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for Microsoft business travel, tech conferences, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — close Eastside courier", "Microsoft and tech corridor travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Redmond adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Eastside address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Redmond residents and families — including Microsoft employees, new citizens, and Eastside families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Redmond residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Redmond and Eastside families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Redmond and Eastside residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Redmond WA", description: "Urgent passport processing for Redmond Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Redmond WA", description: "Fast passport renewal for Redmond Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Redmond WA", description: "New passport application services for Redmond Washington residents applying for their first passport." },
    { name: "Child Passport Redmond WA", description: "Minor passport services for Redmond Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Arjun P.",
      location: "Redmond, WA",
      rating: 5,
      text: "Microsoft conference in Bangalore with 5 days notice and my passport was about to expire. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Redmond Way and the whole process was seamless. Game changer.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jessica & Mark T.",
      location: "Sammamish, WA",
      rating: 5,
      text: "Family trip to Korea with 8 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on 148th Ave and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Brian L.",
      location: "Duvall, WA",
      rating: 5,
      text: "Business trip to London with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Living out here in the Snoqualmie Valley, not having to drive to Seattle is incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Megan K.",
      location: "Redmond, WA",
      rating: 5,
      text: "Lost my passport the week before a team offsite in Dublin. Fast Passport Center replaced it in 48 hours. As a Microsoft PM, I can't afford to miss international events. They saved my trip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "rdw-1",
      name: "Redmond Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7241 185th Ave NE",
      city: "Redmond",
      state: "WA",
      zip: "98052",
      phone: "(425) 885-1121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Redmond, near Redmond Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Redmond acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Microsoft main campus and downtown Redmond.",
      icon: "ri-mail-line",
    },
    {
      id: "rdw-2",
      name: "Sammamish Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22424 SE 4th St",
      city: "Sammamish",
      state: "WA",
      zip: "98074",
      phone: "(425) 868-9023",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sammamish, approximately 8 miles south of downtown Redmond",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Sammamish, Issaquah, and Sammamish Plateau residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "rdw-3",
      name: "Kirkland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11133 120th Ave NE",
      city: "Kirkland",
      state: "WA",
      zip: "98033",
      phone: "(425) 822-5131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kirkland, approximately 6 miles west of downtown Redmond",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kirkland and northwest Redmond residents. Good alternative for west Redmond and the Bridle Trails area.",
      icon: "ri-mail-line",
    },
    {
      id: "rdw-4",
      name: "Bellevue Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1801 136th Pl NE",
      city: "Bellevue",
      state: "WA",
      zip: "98005",
      phone: "(425) 462-0125",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bellevue, approximately 10 miles southwest of downtown Redmond",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest Eastside facility. Good alternative for southwest Redmond and Overlake area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "rdw-5",
      name: "King County Clerk — Seattle",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — approximately 20 minutes via SR-520",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Redmond residents may prefer the Redmond, Kirkland, or Bellevue post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — SR-520 toll bridge to downtown Seattle", fpc: "No — ship from Redmond" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Microsoft & Tech Travel", agency: "No special guidance", fpc: "Yes — global tech travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Redmond Microsoft employees and tech professionals often discover passport issues just before international conferences and offsites. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services at Redmond Town Center or along Redmond Way sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Redmond Post Office appointments fill during tech conference seasons and summer family travel. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating SR-520 Bridge Traffic",
      description: "Many Redmond residents attempt to drive to the Seattle passport agency in an emergency. SR-520 bridge tolls, downtown parking, and Seattle traffic can make a simple errand a half-day commitment — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Tech conference season (year-round on the Eastside) and summer family travel both create steady passport demand — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Redmond area or Eastside tech corridor." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Redmond, Bellevue, or Kirkland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to cross the SR-520 bridge yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Redmond address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Redmond, WA?", a: "Fast Passport Center offers emergency passport processing in Redmond, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — just 20 minutes west via SR-520." },
    { q: "Does Redmond have its own passport agency?", a: "No — Redmond does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 20 minutes west via SR-520). Fast Passport Center's courier service means Redmond residents never need to deal with bridge tolls and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Sammamish, Duvall, or Carnation?", a: "Absolutely. Fast Passport Center serves all of northeastern King County including Sammamish, Duvall, Carnation, Fall City, and the Snoqualmie Valley. Our service works the same way everywhere." },
    { q: "What airport do Redmond travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport for Redmond and the Eastside. SEA is 25–30 minutes via SR-520 or I-405 and offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines are major hubs. Always verify passport validity for at least 6 months past your return date." },
    { q: "Does Fast Passport Center serve Microsoft employees in Redmond?", a: "Yes. Fast Passport Center serves all of the Eastside including Microsoft employees across the Redmond campus. We understand tech corporate travel schedules — from conferences in Europe and Asia to team offsites and customer meetings. Our courier service is ideal for busy Microsoft professionals." },
    { q: "How much does an expedited passport cost in Redmond, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Redmond?", a: "Walgreens, CVS, and Bartell Drugs stores throughout Redmond and Bellevue offer passport photos. UPS Store and FedEx Office locations at Redmond Town Center also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Sammamish Plateau?", a: "Yes. Fast Passport Center serves all of the Eastside including the Sammamish Plateau communities of Sammamish, Issaquah Highlands, and Klahanie. We understand the needs of Eastside families and tech professionals living on the Plateau — our courier service eliminates the need for long drives to Seattle." },
  ],
  photoLocations: [
    { name: "Walgreens — Redmond Way", address: "7979 170th Ave NE, Redmond, WA 98052", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Bartell Drugs — Redmond Town Center", address: "16421 NE 72nd Way, Redmond, WA 98052", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Downtown Redmond", address: "16150 NE 85th St, Redmond, WA 98052", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Bellevue", address: "10600 NE 8th St, Bellevue, WA 98004", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Redmond", address: "14724 NE 31st St, Bellevue, WA 98007", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing closest to Redmond. Located in the Overlake area near the Microsoft campus. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Bellevue", address: "13133 NE 20th St, Bellevue, WA 98005", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Bellevue and south Redmond. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "25–30 minutes from Redmond via SR-520 or I-405",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Redmond and the Eastside. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Asia-Pacific gateway with direct flights to Tokyo, Seoul, Beijing, Singapore, and more.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 25 minutes from Redmond via I-405",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport. Not typically used for international passenger travel. Serves Boeing and corporate aviation.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
    {
      code: "PAE",
      name: "Paine Field (Snohomish County)",
      distance: "Approximately 30 minutes north of Redmond via I-405",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Commercial flights to select domestic destinations. Alaska Airlines and United serve Paine Field. Alternative to SEA for some domestic travel.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: false,
    },
  ],
};